export enum ECvDialogFields {
  title = 'title',
  content = 'content',
  okButtonLabel = 'okButtonLabel',
  cancelButtonLabel = 'cancelButtonLabel',
  includeCv = 'includeCv',
  appendSkillSetLabel = 'appendSkillSetLabel',
  appendProjectListLabel = 'appendProjectListLabel'
}
